<template>
    <div>

        <row-container v-if="hasBanner" :row="bannerRow" index="0" key="0navRow" :layout="layout"></row-container>

        <nav class="navbar navbar-expand-lg navbar-light" :style="rowStyle" :class="navClasses">
            <element-container v-if="firstComponent" :component="firstComponent" :column="block1"
                               class="navbar-brand position-relative"
                               :layout="layout" :key="'brandComponent'"
                               @iconClick="onEditIcon"
                               @imageClick="onEditImage"></element-container>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarNav">
                <Container :should-accept-drop="shouldAcceptDrop" class="navbar-nav column-border"
                           :class="leftNavClasses" tag="ul"
                           @drop="onBlock1Drop('navItems', $event)" style="min-height: 44px;">

                    <li class="nav-item component-container" v-for="(component, columnIndex) in block1.value">
                        <element-container v-if="columnIndex > 0" :component="component" :column="block1"
                                           class="nav-link position-relative"
                                           :layout="layout" :key="componentKey(columnIndex) + '1'"
                                           @iconClick="onEditIcon"
                                           @imageClick="onEditImage"></element-container>
                    </li>
                </Container>
                <Container v-if="block2 !== null" :should-accept-drop="shouldAcceptDrop"
                           class="navbar-nav w-50 column-border justify-content-end" tag="ul"
                           @drop="onBlock2Drop('navItems', $event)" style="min-height: 44px;">

                    <li class="nav-item component-container" v-for="(component, columnIndex) in block2.value">
                        <element-container :component="component" :column="block2"
                                           class="nav-link position-relative"
                                           :layout="layout" :key="componentKey(columnIndex) + '2'"
                                           @iconClick="onEditIcon"
                                           @imageClick="onEditImage"></element-container>
                    </li>
                </Container>
            </div>

            <icon-modal v-if="showIconModal" @noEvent="showIconModal = false"
                        :yesEvent="iconSelected"></icon-modal>

            <image-modal v-if="showImageModal" @noEvent="showImageModal = false" :website="model.website"
                         :yesEvent="imageSelected" key="navImageModal"></image-modal>
        </nav>
    </div>
</template>

<script>
    import {Container} from "vue3-smooth-dnd"
    // import Container from "../../components/draganddrop/components/Container";
    import PageFactory from "../../utils/PageFactory";
    import ImageModal from "./ImageModal.vue";
    import IconModal from "./IconModal.vue";
    import ElementContainer from "./ElementContainer.vue";
    import RowContainer from "../view/RowContainer.vue";

    export default {
        name: 'NavRenderer',
        props: ['layout'],
        components: {
            RowContainer,
            ImageModal,
            IconModal,
            ElementContainer,
            Container
        },
        data() {
            return {
                model: webase.model,
                isMouseOver: false,
                pageFactory: new PageFactory(),
                showIconModal: false,
                iconSelected: function (icon) {
                },
                showImageModal: false,
                imageSelected: function (image) {
                }
            }
        },
        computed: {
            row() {
                return this.layout.rows[this.layout.rows.length - 1]
            },
            bannerRow() {
                return this.layout.rows[0]
            },
            hasBanner() {
                return this.layout.rows.length == 2
            },
            rowStyle() {
                return {
                    backgroundColor: this.row.background && this.row.background.color ? this.row.background.color : '#FFFFFF'
                }
            },
            navClasses() {
                let cssClasses = ''

                if (this.row.shadow) {
                    cssClasses += ' shadow'
                }

                if (this.row.justify && this.row.justify === 'right') {
                    cssClasses += ' justify-content-end'
                }

                return cssClasses.trim()
            },
            leftNavClasses() {
                let cssClasses = this.block2 ? 'w-50' : 'w-100'

                if (this.row.justify && this.row.justify === 'right') {
                    cssClasses += ' justify-content-end'
                } else {
                    cssClasses += ' justify-content-start'
                }

                return cssClasses.trim()
            },
            firstComponent() {
                if (this.block1.value.length > 0) {
                    return this.block1.value[0]
                }

                return null
            },
            block1() {
                return this.row.columns[0]
            },
            block2() {

                if (this.row.columns.length === 2) {
                    return this.row.columns[1]
                }

                return null
            }
        },
        mounted() {
            if (!this.row.justify) {
                this.row.justify = 'left'
            }
        },
        methods: {
            onEditIcon() {
                this.showIconModal = true
                this.iconSelected = (icon) => {
                    this.layout.selectedComponent.value = icon
                }
            },
            onEditImage() {
                this.showImageModal = true
                this.imageSelected = (image) => {
                    this.layout.selectedComponent.value = image
                }
            },
            componentKey(columnIndex) {
                return 'navCompEditor-' + this.index + columnIndex
            },
            onBlock1Drop(collection, dropResult) {
                this.onDrop(collection, dropResult, this.block1)
            },
            onBlock2Drop(collection, dropResult) {
                this.onDrop(collection, dropResult, this.block2)
            },
            onDrop(collection, dropResult, column) {
                if (dropResult.addedIndex === null) {
                    return
                }

                let payload = dropResult.payload

                if (payload.type === 'Icon') {
                    this.showIconModal = true
                    this.iconSelected = (icon) => {
                        let iconComponent = this.pageFactory.createIconComponent(icon)
                        // this.setLabelColor(iconComponent)
                        column.value.push(iconComponent)
                        this.layout.selectedComponent = column.value[column.value.length - 1]
                    }

                    return
                } else if (payload.type === 'Image') {
                    this.showImageModal = true
                    this.imageSelected = (image) => {
                        let imageComponent = this.pageFactory.createImageComponent(image)
                        column.value.push(imageComponent)
                        this.layout.selectedComponent = column.value[column.value.length - 1]
                    }

                    return
                }

                // this.setLabelColor(payload)
                column.value.push(payload)
                this.layout.selectedComponent = column.value[column.value.length - 1]
            },
            shouldAcceptDrop(sourceContainerOptions, payload) {
                return sourceContainerOptions.groupName !== "rowContainers"
            },
        }
    }
</script>